import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
// import createSagaMiddleware from '@redux-saga/core';
import rootReducer from './store/reducers/rootReducer';

const root = ReactDOM.createRoot(document.getElementById("root"));
// const sagaMiddleware = createSagaMiddleware();

const store = configureStore({ reducer: rootReducer });

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
